module.exports = __webpack_public_path__ + "i18n/ja.232addcf0a32b929a917dac0755a9573.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/ja.json
// module id = 1857
// module chunks = 0